import { Box, Typography, Modal, Backdrop, CircularProgress, Chip, TableBody, TableRow, TableCell, Table, TableContainer, Paper, Button, Divider, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CCarousel from "../../basecomp/components/CCarousel_TicketingTool";
import CDropDown2 from "../../basecomp/components/CDropDown2";
import CInput3 from "../../basecomp/components/CInput3";
import { AddComment, GetComments, GetDevelopers, MarkComplete, StartProject } from "../model/generalApiCalls";
import AssignTicketVM from "../viewmodel/AssignTicketVM";
import { StoreFilesApi } from "../model/RaiseTicketApi";
import { useToast } from "../../basecomp/components/provider/ToastProvider";

// Icons
import BugReportIcon from '@mui/icons-material/BugReport';
import BuildIcon from '@mui/icons-material/Build';
import CodeIcon from '@mui/icons-material/Code';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import UploadIcon from '@mui/icons-material/Upload';
import ImageIcon from '@mui/icons-material/Image';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

// CONAS Brand Colors
const CONAS_BLUE = "#163672";
const CONAS_GREEN = "#69b244";

// ==========================================
// UTILITY: Time Calculator
// ==========================================
const calculateTimeTaken = (startTs, endTs) => {
    if (!startTs || !endTs) return null;
    const diffMs = Number(endTs) - Number(startTs);
    if (diffMs <= 0) return "0m"; 

    const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
    const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    let str = "";
    if (days > 0) str += `${days}d `;
    if (hours > 0) str += `${hours}h `;
    if (minutes > 0 || str === "") str += `${minutes}m`;

    return str.trim();
};

// ==========================================
// 1. COMMENT COMPONENTS
// ==========================================

function CommentBox({ commentData, ticketData }) {
    const [openImage, setImageOpen] = useState(false)
    const [totalFileCount, setTotalFileCount] = useState(0)
    const [carousalFilesData, setCarousalFilesData] = useState(null)

    useEffect(() => {
        if (commentData.attachment_id.length === 1 && commentData.attachment_id[0] === null) {
            setTotalFileCount(0)
        } else {
            setTotalFileCount(commentData.attachment_id.length)
        }
    }, [commentData])

    let frontend = "", icon;
    if (commentData.usertype === "Developer") { frontend = CONAS_BLUE; icon = <AccountCircleIcon sx={{ color: frontend }} />; }
    else if (commentData.usertype === "Admin") { frontend = "#ef4444"; icon = <AccountCircleIcon sx={{ color: frontend }} />; }
    else if (commentData.usertype === "User") { frontend = CONAS_GREEN; icon = <AccountCircleIcon sx={{ color: frontend }} />; }

    function handelViewClick() {
        if (totalFileCount !== 0) {
            let Data = commentData.attachment_id.map((elem, index) => ({ "id": elem, "type": commentData.filetypes[index] }));
            setCarousalFilesData(Data)
        }
        setImageOpen(true)
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: frontend, fontWeight: 700 }}>
                {icon} <Typography variant="body2" sx={{ fontWeight: 600 }}>{commentData.usertype}</Typography>
            </Box>
            <Box sx={{ pl: "32px" }}>
                <Box sx={{ p: 2, backgroundColor: "#f8fafc", borderRadius: "12px", border: "1px solid #e2e8f0", color: "#334155" }}>
                    {commentData.comment}
                </Box>
                {totalFileCount !== 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1, cursor: "pointer", color: CONAS_BLUE, width: "fit-content", "&:hover": { textDecoration: "underline" } }} onClick={handelViewClick}>
                        <ImageIcon fontSize="small" />
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>Attachments ({totalFileCount})</Typography>
                    </Box>
                )}
            </Box>
            {openImage && <CCarousel cOpen={openImage} cCloseClicked={() => setImageOpen(false)} cImages={carousalFilesData} cStatus={ticketData.status} cEntity={"Comment"} />}
        </Box>
    )
}

function Comments({ modelOpen, close, ticketData, usertype, commentData,screen }) {
    const { handleToastOpen } = useToast()
    const [ticketComment, setTicketComment] = useState("")
    const [loading, setLoading] = useState(false)
    const [TicketCommentFiles, setTicketCommentFiles] = useState([])

    const handelAddCommentClick = async () => {
        if (!ticketComment && TicketCommentFiles.length === 0) return handleToastOpen("error", "Comment cannot be empty");
        setLoading(true)
        let comment = new FormData()
        comment.append("ticket_id", ticketData.id)
        comment.append("usertype", usertype)
        comment.append("comment", ticketComment)
        if (TicketCommentFiles.length !== 0) {
            let newFileList = Array.from(TicketCommentFiles).map((file) => ({ "name": file.name, "type": file.type }));
            comment.append("files", JSON.stringify(newFileList))
        }
        let response;
        try {
            response = await AddComment(comment)
            handleToastOpen("success", "Comment Added")

            if (response.data.preAssignedUrl.length !== 0) {
                let s3response = response.data.preAssignedUrl.map(async (elem, index) => {
                    return fetch(elem.url, { method: "PUT", headers: { "Content-Type": elem.filetype }, body: TicketCommentFiles[index] })
                })
                let allResponses = await Promise.all(s3response)
                let uploaded = allResponses.every((elem) => elem.ok);
                if (uploaded) {
                    let newfileDetails = response.data.preAssignedUrl.map((elem) => ({ "key": elem.key, "filetype": elem.filetype, "filename": elem.filename }))
                    let fileDetailsToSend = new FormData()
                    fileDetailsToSend.append("ticket_id", response.data.comment_id)
                    fileDetailsToSend.append("fileDetails", JSON.stringify(newfileDetails))
                    fileDetailsToSend.append("entity", "Comment")
                    await StoreFilesApi(fileDetailsToSend)
                }
            }
            setLoading(false); close(false);
        }
        catch (error) {
            handleToastOpen("error", "Something unexpected happened")
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <Modal open={modelOpen} onClose={(e, r) => { if (r !== "backdropClick") close(false) }}>
            <Box sx={{ width: { xs: "95vw", sm: "600px" }, bgcolor: "white", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", borderRadius: "20px", p: 4, display: "flex", flexDirection: "column", gap: 3, maxHeight: "85vh", boxShadow: 24 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", pb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>Discussion Thread</Typography>
                    <IconButton onClick={() => close(false)} size="small"><CloseIcon /></IconButton>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", overflowY: "auto", flexGrow: 1, pr: 1 }}>
                    {commentData && commentData.length > 0 ? commentData.map((elem, i) => <CommentBox commentData={elem} key={i} ticketData={ticketData} />) : <Typography sx={{ color: "#94a3b8", textAlign: "center", py: 4 }}>No comments yet. Start the conversation!</Typography>}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, borderTop: "1px solid #e2e8f0", pt: 2 }}>
                    <CInput3 cHintText="Write a comment..." cRows={3} cValue={ticketComment} cOnChange={(e) => setTicketComment(e.target.value)} />
                    <input type="file" multiple id="inputfile-comment" accept="image/*,video/*" style={{ display: "none" }}
                        onChange={(e) => {
                            const valid = Array.from(e.target.files).every(f => (f.type.startsWith("image/") || f.type.startsWith("video/")) && f.size <= 50 * 1024 * 1024);
                            valid ? setTicketCommentFiles(e.target.files) : alert("Only images/videos under 50MB allowed.");
                        }} />
                    <label htmlFor="inputfile-comment">
                        <Box sx={{ width: "100%", border: "1px dashed #cbd5e1", borderRadius: "10px", py: 1.5, display: "flex", justifyContent: "center", alignItems: "center", gap: 1, cursor: "pointer", bgcolor: "#f8fafc", "&:hover": { borderColor: CONAS_BLUE } }}>
                            <UploadIcon sx={{ color: "#64748b", fontSize: 20 }} />
                            <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 500 }}>{TicketCommentFiles.length === 0 ? "Attach Files (Optional)" : `${TicketCommentFiles.length} file(s) selected`}</Typography>
                        </Box>
                    </label>
                    <Button variant="contained" disabled={usertype==="User" && screen && screen !=="view"} onClick={handelAddCommentClick} sx={{ backgroundColor: CONAS_BLUE, textTransform: "none", fontWeight: 600, py: 1.2, borderRadius: "10px", "&:hover": { backgroundColor: "#112a59" } }}>Post Comment</Button>
                </Box>
                <Backdrop open={loading} sx={{ zIndex: 9999, color: '#fff' }}><CircularProgress /></Backdrop>
            </Box>
        </Modal>
    )
}

// ==========================================
// 2. ASSIGN TICKET MODAL
// ==========================================

function AssignTicket({ modelOpen, close, ticketData, assingBtn }) {
    const [employeeName, setEmployee] = useState("")
    const [data, setEmployeeData] = useState([])
    const [loading, setLoading] = useState(false)
    const { handleToastOpen } = useToast()

    useEffect(() => {
        const fetchDevs = async () => {
            let response = await GetDevelopers()
            let newData = Array.from(response.data).map((elem) => elem.name + " " + elem.id)
            setEmployeeData(newData)
        }
        fetchDevs()
    }, [])

    const handelAssignDevClick = async () => {
        setLoading(true)
        try {
            await AssignTicketVM(employeeName, ticketData.id)
            assingBtn("Assigned", true)
        }
        catch (error) {
            handleToastOpen("error", "Something unexpected happened")
        }
        finally {
            setLoading(false)
            close(false)
        }
    }

    return (
        <Modal open={modelOpen} onClose={(e, r) => { if (r !== "backdropClick") close(false) }}>
            <Box sx={{ width: { xs: "95vw", sm: "400px" }, bgcolor: "white", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", borderRadius: "20px", p: 4, display: "flex", flexDirection: "column", gap: 3, boxShadow: 24 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", pb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>Assign Developer</Typography>
                    <IconButton onClick={() => close(false)} size="small"><CloseIcon /></IconButton>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <CDropDown2 cHelperText="Select Developer" cOnChange={(e) => setEmployee(e)} cData={data} />
                    <Button variant="contained" disabled={!employeeName} onClick={handelAssignDevClick} sx={{ backgroundColor: CONAS_BLUE, color: "white", textTransform: "none", fontWeight: 600, py: 1.2, borderRadius: "10px", "&:hover": { backgroundColor: "#112a59" } }}>Confirm Assignment</Button>
                </Box>
                <Backdrop open={loading} sx={{ zIndex: 9999, color: '#fff' }}><CircularProgress /></Backdrop>
            </Box>
        </Modal>
    )
}

// ==========================================
// 3. VIEW DETAILS MODAL (WITH TIMESTAMPS)
// ==========================================

function ViewDetails({ modelOpen, close, ticketData, background, forground, usertype }) {
    const [openImage, setImageOpen] = useState(false)
    const [carousalFilesData, setCarousalFilesData] = useState(null)
    let totalCount = ticketData.attachment_id.length === 1 && ticketData.attachment_id[0] === null ? 0 : ticketData.attachment_id.length

    const handelViewClick = () => {
        if (totalCount !== 0) {
            let Data = ticketData.attachment_id.map((elem, index) => ({ "id": elem, "type": ticketData.file_types[index] }))
            setCarousalFilesData(Data)
        }
        setImageOpen(true)
    }

    const MetaRow = ({ icon, label, value }) => (
        <Box sx={{ display: "flex", flexDirection: "column", mb: 2.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#64748b", mb: 0.5 }}>
                {icon} <Typography variant="caption" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</Typography>
            </Box>
            <Box sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0", color: "#1e293b", fontWeight: 500 }}>
                {value || "N/A"}
            </Box>
        </Box>
    )

    return (
        <Modal open={modelOpen} onClose={(e, r) => { if (r !== "backdropClick") close(false) }}>
            <Box sx={{ width: { xs: "95vw", md: "700px" }, bgcolor: "white", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", borderRadius: "20px", p: 4, display: "flex", flexDirection: "column", gap: 3, maxHeight: "85vh", overflowY: "auto", boxShadow: 24, fontFamily: "'Inter', sans-serif" }}>

                {/* Header */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", pb: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <ArticleIcon sx={{ color: CONAS_BLUE }} />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>Ticket Details</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Chip label={ticketData.status} sx={{ bgcolor: background, color: forground, fontWeight: 700, borderRadius: "8px" }} />
                        <IconButton onClick={() => close(false)} size="small"><CloseIcon /></IconButton>
                    </Box>
                </Box>

                <Box>
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 1 }}>
                        <MetaRow icon={<ArticleIcon fontSize="small" />} label="Ticket ID" value={ticketData.ticket_id_unique} />
                        <MetaRow icon={<BuildIcon fontSize="small" />} label="Affected Tool" value={ticketData.tool} />
                    </Box>

                    {/* Timeline Table with Durations */}
                    <Box sx={{ mb: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#64748b", mb: 0.5 }}>
                            <CalendarMonthIcon fontSize="small" /> <Typography variant="caption" sx={{ fontWeight: 600, textTransform: "uppercase" }}>Timeline & Turnaround</Typography>
                        </Box>
                        <TableContainer component={Paper} sx={{ borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "none" }}>
                            <Table size="small">
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 600, width: "33%", textAlign: "center" }}>Submitted</TableCell>
                                        <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 600, width: "33%", textAlign: "center" }}>Assigned</TableCell>
                                        <TableCell sx={{ bgcolor: "#f8fafc", fontWeight: 600, width: "33%", textAlign: "center" }}>Closed</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {/* 1. Submitted Column */}
                                        <TableCell sx={{ textAlign: "center", py: 2 }}>
                                            {ticketData.created_at
                                                ? <Typography variant="body2">{new Date(Number(ticketData.created_at)).toLocaleString("en-IN", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" })}</Typography>
                                                : "-"
                                            }
                                        </TableCell>

                                        {/* 2. Assigned Column (Shows Time from Submitted) */}
                                        <TableCell sx={{ textAlign: "center", py: 2 }}>
                                            {ticketData.status !== "Pending" && ticketData.assigned_at
                                                ? (
                                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                                                        <Typography variant="body2">
                                                            {new Date(Number(ticketData.assigned_at)).toLocaleString("en-IN", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" })}
                                                        </Typography>
                                                        {/* Duration Badge */}
                                                        <Chip 
                                                            size="small" 
                                                            label={`Took ${calculateTimeTaken(ticketData.created_at, ticketData.assigned_at)}`} 
                                                            sx={{ bgcolor: "#eef2ff", color: CONAS_BLUE, fontWeight: 700, fontSize: "0.7rem", height: "20px" }} 
                                                        />
                                                    </Box>
                                                )
                                                : "-"
                                            }
                                        </TableCell>

                                        {/* 3. Closed Column (Shows Time from Assigned/Started) */}
                                        <TableCell sx={{ textAlign: "center", py: 2 }}>
                                            {(ticketData.status === "Resolved" || ticketData.status === "Completed") && ticketData.updated_at
                                                ? (
                                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                                                        <Typography variant="body2">
                                                            {new Date(Number(ticketData.updated_at)).toLocaleString("en-IN", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" })}
                                                        </Typography>
                                                        {/* Duration Badge */}
                                                        <Chip 
                                                            size="small" 
                                                            label={`Took ${calculateTimeTaken(ticketData.assigned_at || ticketData.created_at, ticketData.updated_at)}`} 
                                                            sx={{ bgcolor: "#f0f7ec", color: CONAS_GREEN, fontWeight: 700, fontSize: "0.7rem", height: "20px" }} 
                                                        />
                                                    </Box>
                                                )
                                                : "-"
                                            }
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 1 }}>
                        {(usertype === "Admin" || usertype === "Developer") && <MetaRow icon={<PersonOutlineIcon fontSize="small" />} label="Created By" value={ticketData.created_name} />}
                        {(ticketData.status !== "Pending" && usertype!=="User" && usertype!=="Developer") && <MetaRow icon={<AssignmentIndIcon fontSize="small" />} label="Assigned To" value={ticketData.emp_name} />}
                    </Box>

                    <MetaRow icon={<DescriptionIcon fontSize="small" />} label="Detailed Description" value={ticketData.description} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", bgcolor: "#f8fafc", p: 2, borderRadius: "10px", border: "1px dashed #cbd5e1" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#475569" }}>
                            <ImageIcon fontSize="small" />
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Attachments ({totalCount})</Typography>
                        </Box>
                        <Button variant="outlined" size="small" disabled={totalCount === 0} onClick={handelViewClick} sx={{ color: CONAS_BLUE, borderColor: CONAS_BLUE, textTransform: "none", borderRadius: "8px", "&:hover": { borderColor: "#112a59", bgcolor: "#eef2ff" } }}>View Files</Button>
                    </Box>
                </Box>
                {openImage && <CCarousel cOpen={openImage} cCloseClicked={() => setImageOpen(false)} cImages={carousalFilesData} cStatus={ticketData.status} cEntity={"Ticket"} />}
            </Box>
        </Modal>
    )
}

// ==========================================
// 4. MINIMAL TICKET CARD
// ==========================================

function TicketCards({ id, ticketData, usertype, screen, handelassignedTickets }) {

    let ticketType = ticketData.type || "IT Tool Access";

    // CONAS Integrated Type Styling
    let typeColor = CONAS_BLUE, softTypeColor = "#eef2ff", TypeIcon = CodeIcon; 

    if (ticketType === "Bug") {
        typeColor = "#ef4444"; softTypeColor = "#fee2e2"; TypeIcon = BugReportIcon;
    } else if (ticketType === "Improvement") {
        typeColor = CONAS_GREEN; softTypeColor = "#f0f7ec"; TypeIcon = BuildIcon;
    }

    // Rely on local `statusText` state for dynamic colors
    const [statusText, setStatustext] = useState(ticketData.status);
    
    let statusColor = "#d97706", softStatusColor = "#fef3c7", StatusIcon = AccessTimeIcon;
    if (statusText === "Resolved" || statusText === "Completed") {
        statusColor = CONAS_GREEN; softStatusColor = "#f0f7ec"; StatusIcon = CheckCircleOutlineIcon;
    } else if (statusText === "Assigned" || statusText === "Started") {
        statusColor = CONAS_BLUE; softStatusColor = "#eef2ff"; StatusIcon = AccessTimeIcon;
    }

    // State
    const [detailsModelOpen, setDetailsModelOpen] = useState(false);
    const [assignModelOpen, setAssignModelOpen] = useState(false);
    const [openCommentModel, setOpenComment] = useState(false);
    const [commentData, setCommentData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [assignDisabled, setAssignDisabled] = useState(false);
    const [assingButtonText, setAssignBtnText] = useState("Assign");

    const isDeveloper = usertype === "Developer";
    const isAdmin = usertype === "Admin";

    // Actions
    const handelCommentClick = async () => {
        let response = await GetComments(ticketData.id)
        setCommentData(response.data.comments)
        setOpenComment(true)
    }

    const handelCompleteClick = async () => {
        setLoading(true);
        let data = new FormData(); data.append("ticket_id", ticketData.id);
        await MarkComplete(data);
        
        setStatustext("Resolved"); 
        handelassignedTickets();     
        setLoading(false);
    }

    const handelStartClick = async () => {
        setLoading(true);
        let data = new FormData(); data.append("ticket_id", ticketData.id);
        await StartProject(data);
        
        setStatustext("Started"); 
        setLoading(false);
    }

    return (
        <Paper elevation={0} sx={{
            width: "100%",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            borderLeft: `6px solid ${typeColor}`,
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column",
            mb: 2,
            transition: "all 0.2s ease",
            fontFamily: "'Inter', sans-serif",
            "&:hover": { boxShadow: "0px 8px 24px rgba(0,0,0,0.04)" }
        }}>

            <Box sx={{ p: 2.5, display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box sx={{ width: 48, height: 48, borderRadius: "12px", bgcolor: softTypeColor, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <TypeIcon sx={{ color: typeColor, fontSize: 28 }} />
                    </Box>

                    <Box>
                        <Chip
                            label={ticketType}
                            size="small"
                            sx={{
                                bgcolor: softTypeColor,
                                color: typeColor,
                                height: "20px",
                                fontSize: "0.75rem",
                                fontWeight: 800,
                                borderRadius: "6px",
                                mb: 0.5
                            }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b", lineHeight: 1.2, fontFamily: "'Inter', sans-serif" }}>
                            {ticketData.heading}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 0.5, color: "#64748b", fontSize: "0.85rem", fontWeight: 500, flexWrap: "wrap" }}>
                            <Typography variant="inherit">ID: {ticketData.ticket_id_unique}</Typography>
                            <Typography variant="inherit" sx={{ color: "#cbd5e1" }}>•</Typography>
                            <Typography variant="inherit">Tool: {ticketData.tool}</Typography>
                        </Box>
                    </Box>
                </Box>

                <Chip icon={<StatusIcon style={{ fontSize: 16, color: statusColor }} />} label={statusText}
                    sx={{ bgcolor: softStatusColor, color: statusColor, fontWeight: 700, borderRadius: "20px", pl: 0.5, flexShrink: 0 }} />
            </Box>

            <Divider sx={{ borderColor: "#f1f5f9" }} />

            <Box sx={{ px: 2.5, py: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center", bgcolor: "#f8fafc", flexWrap: "wrap", gap: 2 }}>

                <Button variant="outlined" startIcon={<ChatBubbleOutlineIcon fontSize="small" />} onClick={handelCommentClick}
                    sx={{ color: CONAS_BLUE, borderColor: "#e2e8f0", borderRadius: "50px", textTransform: "none", fontWeight: 600, bgcolor: "#fff", "&:hover": { bgcolor: "#eef2ff", borderColor: CONAS_BLUE } }}>
                    Comments
                </Button>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>

                    {isAdmin && screen === "pending" && statusText !== "Assigned" && (
                        <Button variant="contained" disabled={assignDisabled} onClick={() => setAssignModelOpen(true)}
                            sx={{ bgcolor: CONAS_BLUE, color: "#fff", borderRadius: "50px", textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { bgcolor: "#112a59", boxShadow: "none" } }}>
                            {assingButtonText}
                        </Button>
                    )}

                    {isDeveloper && screen === "assigned" && statusText !== "Started" && statusText !== "Resolved" && (
                        <Button variant="contained" startIcon={<PlayArrowIcon />} onClick={handelStartClick}
                            sx={{ bgcolor: CONAS_BLUE, color: "#fff", borderRadius: "50px", textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { bgcolor: "#112a59", boxShadow: "none" } }}>
                            Start Task
                        </Button>
                    )}

                    {isDeveloper && screen === "assigned" && statusText === "Started" && (
                        <Button variant="contained" startIcon={<CheckIcon />} onClick={handelCompleteClick}
                            sx={{ bgcolor: CONAS_GREEN, color: "#fff", borderRadius: "50px", textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { bgcolor: "#559635", boxShadow: "none" } }}>
                            Mark Complete
                        </Button>
                    )}

                    <Button variant="contained" endIcon={<ChevronRightIcon />} onClick={() => setDetailsModelOpen(true)}
                        sx={{ bgcolor: "#eef2ff", color: CONAS_BLUE, borderRadius: "50px", textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { bgcolor: "#d0dbf2", boxShadow: "none" } }}>
                        View Details
                    </Button>
                </Box>
            </Box>

            {/* Render Modals */}
            {detailsModelOpen && <ViewDetails modelOpen={detailsModelOpen} close={setDetailsModelOpen} ticketData={ticketData} forground={statusColor} background={softStatusColor} usertype={usertype} />}
            {assignModelOpen && <AssignTicket modelOpen={assignModelOpen} assingBtn={(text, dis) => { setAssignBtnText(text); setStatustext("Assigned"); setAssignDisabled(dis) }} close={setAssignModelOpen} ticketData={ticketData} />}
            {openCommentModel && <Comments modelOpen={openCommentModel} close={setOpenComment} ticketData={ticketData} commentData={commentData} usertype={usertype} screen={screen} />}

            <Backdrop open={loading} sx={{ zIndex: 9999, color: '#fff' }}><CircularProgress /></Backdrop>
        </Paper>
    )
}

// ==========================================
// 5. LIST COMPONENT
// ==========================================

function TicketList({ ticketData, usertype, screen, handelassignedTickets }) {
    let forground = "", icon;
    if (screen === "pending") { forground = "#d97706"; icon = <ErrorOutlineIcon sx={{ color: forground, fontSize: "4rem" }} /> }
    else if (screen === "completed") { forground = CONAS_GREEN; icon = <CheckCircleOutlineIcon sx={{ color: forground, fontSize: "4rem" }} /> }
    else if (screen === "assigned") { forground = CONAS_BLUE; icon = <MailOutlineIcon sx={{ color: forground, fontSize: "4rem" }} /> }

    return (
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
            {ticketData && ticketData.length !== 0 ? (
                ticketData.map((ticket, index) => (
                    <TicketCards handelassignedTickets={handelassignedTickets} ticketData={ticket} key={ticket.id} id={index + 1} usertype={usertype} screen={screen} />
                ))
            ) : (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: 2, py: 10, bgcolor: "#f8fafc", borderRadius: "20px", border: "1px dashed #cbd5e1" }}>
                    {icon}
                    <Typography variant="h6" sx={{ color: "#64748b", fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>No {screen ?? ""} tickets found</Typography>
                </Box>
            )}
        </Box>
    )
}

export default TicketList;